import { SET_CAMPAIGN_MEMBER_ID } from 'actions';

export function setCampaignMemberId(campaignMemberId: string) {
  return { campaignMemberId, type: SET_CAMPAIGN_MEMBER_ID };
}
